<script>
	import SecondaryStatsComponent from "./SecondaryStatsComponent.svelte"
	export let lang, selectedReviewForDialog, photoIndex, mapSecondaryRatings

	let anonymousText = lang == 'en' ? 'Anonymous' : 'Anonyme';

	$:console.log(selectedReviewForDialog)
	$:console.log('photoIndex: ',photoIndex)
</script>


<div class="TwoUp">
	<figure>
		<slot name="left-arrow"></slot>
		<img src="{selectedReviewForDialog?.Photos[photoIndex]?.Sizes?.large?.Url}" alt="Review Photos" width="150" height="150"/>
		<slot name="right-arrow"></slot>
	</figure>
	<section>
		<div class="review-item--details">
		  <div>
			<!-- <RatingInfo review={review} /> -->
			<div class="stars-layout">
			  <div class="Rating" style="--rating: {selectedReviewForDialog?.Rating ?? 0}"></div>
			</div>
			<h4>{selectedReviewForDialog?.Title ? selectedReviewForDialog.Title : selectedReviewForDialog.ReviewText.slice(0, 20)}</h4>
			{#if selectedReviewForDialog.SubmissionTime}
			   <div>
				 {
				   new Date(selectedReviewForDialog.SubmissionTime).toLocaleDateString("en-US", {
						 month: "short",
						 day: "2-digit",
						 year: "numeric",
				   })
				 }
			   </div>
			{/if}
			<span class="review-item--details-text">{selectedReviewForDialog.ReviewText}</span>

			<div class="review--thumbnails">
				<slot name="horizontal_images"></slot>
			</div>

			<!-- {#if selectedReviewForDialog?.Photos && selectedReviewForDialog.Photos.length}
				<hh-horizontal-nav unstyled>
					{#each selectedReviewForDialog?.Photos as photo}
						<img src="{photo?.Sizes?.large?.Url}" height="80" width="80" loading="lazy" alt="{photo.Caption ||'Review thumbnail'}"/>
					{/each}
				</hh-horizontal-nav>
			{/if} -->
		  </div>
		</div>
		<div class="review-item--stats">
			{#if Object.entries(selectedReviewForDialog.SecondaryRatings).length}
				<SecondaryStatsComponent title={lang== 'en' ? 'Customer Ratings' : 'Évaluations des clients'} secondaryRatings={mapSecondaryRatings(selectedReviewForDialog.SecondaryRatings, selectedReviewForDialog.SecondaryRatingsOrder)} />
			{/if}
		</div>

		<div class="review-item--author">
			{#if selectedReviewForDialog.Badges.hasOwnProperty('StaffYes')}
				<div class="hh-badge">
					<span>
					<img src="/_icons/hh-logo.svg" alt="Home Hardware Logo" height="20" width="auto">
					Certified Staff Review
					</span>
				</div>
			{/if}
			{#if selectedReviewForDialog?.SyndicationSource}
			<div class="review-syndication">
				<span>
					<img src="{selectedReviewForDialog.SyndicationSource?.LogoImageUrl}" alt="Review Logo" height="20" width="auto" />
					Originally posted on {selectedReviewForDialog.SyndicationSource?.Name}
				</span>
			</div>
			{/if}
		</div>
	</section>
</div>

<style>
	.TwoUp {
		align-items: center !important;
		height: 75dvh !important;
	}
	.TwoUp > figure {
		border-radius: 5px;
		/* border: 2px solid var(--hh-grey); */
		background: var(--hh-black);
		aspect-ratio: 1/1;
		width: 100%;
		height: auto;
	}
	.TwoUp > figure > img {
		object-fit: contain !important;
		width: auto;
		height: 100%;
	}
	.TwoUp > section {
		display: flex;
		flex-direction: column;
		/* justify-content: space-between; */
		gap: var(--gap);
		height: 100%;
		max-height: 660px;
		overflow: auto;
	}
	.TwoUp > section > div > div {
		display: flex;
		flex-direction: column;
		gap: calc(var(--gap) / 3);
	}
	.review-item--details > div > .stars-layout > div {
		line-height: 1.4;
	}
	.review-item--author {
		display: flex;
		/* flex-direction: column; */

	}
	.review-syndication > span,
	.hh-badge > span {
		display: inline-flex;
		gap: calc(var(--gap) / 3);
		align-items: center;
		padding: 5px;
		border: 1px solid var(--hh-grey);
		border-radius: 5px;
	}

	/* .review-item--details-text {
		display: inline-block;
		height: 10ch;
		overflow-y: auto;
	} */

	@media (max-width: 1100px) {
		.TwoUp > figure {
			aspect-ratio: 3 / 4 !important;
		}
	}

	@media (max-width: 900px) {
		.TwoUp {
			grid-template-columns: 1fr;
			grid-template-rows: auto 1fr;
		}
		.TwoUp > figure {
			aspect-ratio: 4/3 !important;
			position: relative;
		}
		.TwoUp > section {
			max-height: 100%;
		}
	}
</style>